import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
// 1. Import your components
import Login from "./../Pages/Login";

import { API, UPLOADS } from "./../../config/api";
import HorizontalAds from "../../Admin/Pages/HorizontalAds";

export default function Wishlist() {
  const [cart, setCart] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [imageIndexes1, setImageIndexes1] = useState({});
  const nextImage1 = (e, item, images) => {
    e.stopPropagation();

    const current = imageIndexes1[item.id] || 0;

    if (current >= images.length - 1) {
      navigate(`/houserentdetails/${item.id}`);
      return;
    }

    setImageIndexes1((prev) => ({
      ...prev,
      [item.id]: current + 1,
    }));
  };

  const prevImage1 = (e, item) => {
    e.stopPropagation();

    const current = imageIndexes1[item.id] || 0;

    if (current === 0) return;

    setImageIndexes1((prev) => ({
      ...prev,
      [item.id]: current - 1,
    }));
  };
  // 2. States for the popups
  const [showLogin, setShowLogin] = useState(false);

  const [wishlist, setWishlist] = useState([]);
  const [user, setUser] = useState(null);

  const handleCardClick = (design) => {
    navigate(`/design-details/${design.id}`, { state: design });
  };

  const cartIds = cart.filter((i) => i.type === "design").map((i) => i.id);

  /* ================= LOAD DATA ================= */
  useEffect(() => {
    const loadData = () => {
      const loginUser = JSON.parse(sessionStorage.getItem("user"));
      setUser(loginUser);

      if (loginUser) {
        const savedWishlist =
          JSON.parse(localStorage.getItem(`wishlist_${loginUser.id}`)) || [];
        setWishlist(savedWishlist);

        const savedCart =
          JSON.parse(localStorage.getItem(`cart_${loginUser.id}`)) || [];
        setCart(savedCart);
      }
    };

    loadData();
    window.addEventListener("userLogin", loadData);
    window.addEventListener("userLogout", loadData);

    return () => {
      window.removeEventListener("userLogin", loadData);
      window.removeEventListener("userLogout", loadData);
    };
  }, []);

  const addToCart = (item, type) => {
    if (!user) {
      setShowLogin(true);
      return;
    }

    let existingCart =
      JSON.parse(localStorage.getItem(`cart_${user.id}`)) || [];

    const alreadyExists = existingCart.find(
      (i) => i.id === item.id && i.type === type,
    );

    if (alreadyExists) {
      // REMOVE from cart
      existingCart = existingCart.filter(
        (i) => !(i.id === item.id && i.type === type),
      );
    } else {
      // ADD to cart
      existingCart.push({
        ...item,
        type,
      });
    }

    localStorage.setItem(`cart_${user.id}`, JSON.stringify(existingCart));

    setCart(existingCart);

    // update navbar count
    window.dispatchEvent(new Event("cartUpdated"));
  };
  const removeFromWishlist = (id, type) => {
    const updated = wishlist.filter(
      (item) => !(item.id === id && item.type === type),
    );
    setWishlist(updated);
    localStorage.setItem(`wishlist_${user.id}`, JSON.stringify(updated));

    // TRIGGER NAVBAR UPDATE
    window.dispatchEvent(new Event("cartUpdated"));
  };
  /* ================= FILTER BY TYPE ================= */
  const machines = wishlist.filter((i) => i.type === "machine");
  const designers = wishlist.filter((i) => i.type === "designer");
  const houses = wishlist.filter((i) => i.type === "house");
  const designs = wishlist.filter((i) => i.type === "design");
  const [imageIndexes, setImageIndexes] = useState({});
  const nextImage = (e, item, images) => {
    e.stopPropagation();

    const current = imageIndexes[item.id] || 0;

    if (current >= images.length - 1) {
      navigate(`/productdetails/${item.id}`);
      return;
    }

    setImageIndexes((prev) => ({
      ...prev,
      [item.id]: current + 1,
    }));
  };

  const prevImage = (e, item) => {
    e.stopPropagation();

    const current = imageIndexes[item.id] || 0;

    if (current === 0) return;

    setImageIndexes((prev) => ({
      ...prev,
      [item.id]: current - 1,
    }));
  };
  /* ================= LOGIN CHECK RENDER ================= */
  if (!user) {
    return (
      <div className="container text-center mt-5 py-5 border rounded bg-light shadow-sm">
        <i className="bi bi-heart-break fs-1 text-muted"></i>
        <h4 className="mt-3 fw-bold">Please Login to View Your Wishlist</h4>
        <p className="text-muted">
          Save your favorite designs, machines, and workspaces to view them
          here.
        </p>

        {/* Trigger Pop-up */}

        <div className="d-flex justify-content-center mt-3">
          <button
            className="btn btn-primary px-5 py-2 fw-bold"
            onClick={() => setShowLogin(true)}
          >
            Login Now
          </button>
        </div>

        {/* Pop-up components */}
        <Login
          isOpen={showLogin}
          onClose={() => setShowLogin(false)}
          openRegister={() => {
            setShowLogin(false);
            navigate("/register", {
              state: { from: location.pathname },
            });
          }}
        />
      </div>
    );
  }
  const allWishlistItems = [...machines, ...designers, ...houses, ...designs];
  return (
    <div className="container-fluid wishlist-page">
      <div className="row">
        {/* ================= LEFT ================= */}

        <div className="col-lg-12">
          <h2 className="section-title mb-4">
            My Wishlist ({wishlist.length})
          </h2>
          <div className="designs-grid1">
            {allWishlistItems.map((item) => {
              /* ================= MACHINE ================= */
              if (item.type === "machine") {
                const images = item.image ? item.image.split(",") : [];

                return (
                  <div
                    className="design-card"
                    key={item.id}
                    onClick={() => navigate(`/productdetails/${item.id}`)}
                    style={{ cursor: "pointer" }}
                  >
                    {/* <div className="machine-img-container">
                                          <img
                                            src={`${UPLOADS.MACHINE_IMAGE}${item.user_id}/${images[0]}?t=${Date.now()}`}
                                            alt={item.machine_name}
                                          />
                                          <span className="heads-badge">
                                            {item.NoOfHeads || "Multi"} Heads
                                          </span>
                                        </div> */}
                    <div
                      className="machine-img-container"
                      onClick={() => navigate(`/productdetails/${item.id}`)}
                    >
                      {/* <img
                                          src={`${UPLOADS.MACHINE_IMAGE}${item.user_id}/${images[0]}?t=${Date.now()}`}
                                          alt={item.machine_name}
                                        /> */}
                      <img
                        src={`${UPLOADS.MACHINE_IMAGE}${item.user_id}/${
                          images[imageIndexes[item.id] || 0]
                        }?t=${Date.now()}`}
                        alt={item.machine_name}
                      />
                      {images.length > 1 && (
                        <>
                          {(imageIndexes[item.id] || 0) > 0 && (
                            <button
                              className="img-arrow left-arrow"
                              onClick={(e) => prevImage(e, item)}
                            >
                              <i className="bi bi-chevron-left"></i>
                            </button>
                          )}

                          <button
                            className="img-arrow right-arrow"
                            onClick={(e) => nextImage(e, item, images)}
                          >
                            <i className="bi bi-chevron-right"></i>
                          </button>
                        </>
                      )}
                      {images.length > 1 && (
                        <div className="image-count">
                          <i className="bi bi-images me-1"></i>+
                          {images.length - 1}
                        </div>
                      )}
                      <span className="heads-badge">
                        {item.NoOfHeads} Heads
                      </span>
                    </div>
                    <div className="machine-body">
                      <div className="machine-type">
                        <h4 className="machine-name">{item.machine_name}</h4>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mt-2">
                        <div className="price-block">
                          <span className="currency-symbol">₹</span>
                          <span className="amount">
                            {Number(item.price).toLocaleString("en-IN")}
                          </span>
                        </div>
                      </div>
                      <div className="spec-row mt-0 mb-0">
                        <div className="spec-item">
                          <span className="spec-label">Brand:</span>
                          <span className="spec-value">{item.brand}</span>
                        </div>
                        <div className="spec-item">
                          <span className="spec-label">Area:</span>
                          <span className="spec-value">{item.Area}</span>
                        </div>
                      </div>
                      <div className="spec-item mt-0 p-1">
                        <span className="spec-label1">
                          {" "}
                          <i className="bi bi-person-fill me-2"></i>
                          {item.name}
                        </span>
                      </div>
                      <div className="location-info mb-0 p-1">
                        <i className="bi bi-geo-alt-fill"></i> {item.city},{" "}
                        {item.state}
                      </div>

                      <div className="machine-footer mt-0">
                        <button
                          className="more-details-btn"
                          onClick={(e) => {
                            e.stopPropagation();

                            navigate(`/productdetails/${item.id}`, {
                              state: {
                                activeTab: "seller",
                              },
                            });
                          }}
                        >
                          <i className="bi bi-telephone-fill me-1"></i>
                          Contact Supplier
                        </button>
                        <button
                          className="footer-like-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            removeFromWishlist(item.id, "machine");
                          }}
                        >
                          <i className="bi bi-heart-fill text-danger"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              }

              /* ================= DESIGNER ================= */
              if (item.type === "designer") {
                return (
                  <div
                    className="design-card"
                    key={item.id}
                    onClick={() => navigate(`/designerdetails/${item.id}`)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="machine-img-container">
                      <img
                        src={`${UPLOADS.DESIGNER_IMAGE}${item.profile}`}
                        className="designer-img"
                        alt={item.name}
                        style={{
                          height: "100%",
                          objectFit: "cover",
                          width: "100%",
                        }}
                      />
                      {/* <span className="heads-badge">{item.experience} Exp</span> */}
                    </div>
                    <div className="machine-body">
                      <h4 className="machine-name">{item.name}</h4>
                      <div className="d-flex align-items-center justify-content-between mt-2">
                        <div className="price-block">
                          <span className="currency-symbol">₹</span>
                          <span className="amount">{item.expected_salary}</span>
                          <span className="text-muted small"> / hr</span>
                        </div>
                      </div>
                      <div className="spec-row mt-3">
                        <div className="spec-item">
                          <span className="spec-label">Skills:</span>
                          <span className="spec-value">{item.skills}</span>
                        </div>

                        <div className="spec-item">
                          <span className="spec-label">Exp:</span>
                          <span className="spec-value">{item.experience}</span>
                        </div>
                      </div>
                      <div className="location-info mt-1">
                        <i className="bi bi-geo-alt-fill text-secondary me-1"></i>{" "}
                        {item.location}
                      </div>
                      <div className="machine-footer mt-1">
                        <button
                          className="more-details-btn"
                          onClick={(e) => {
                            e.stopPropagation();

                            navigate(`/designerdetails/${item.id}`, {
                              state: {
                                activeTab: "contact",
                              },
                            });
                          }}
                        >
                          <i className="bi bi-person-badge-fill me-2"></i> Hire
                          Now
                        </button>

                        <button
                          className="footer-like-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            removeFromWishlist(item.id, "designer");
                          }}
                        >
                          <i className="bi bi-heart-fill text-danger"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              }

              /* ================= WORKSPACE ================= */
              if (item.type === "house") {
                const images = item.image ? item.image.split(",") : [];

                return (
                  <div
                    className="design-card"
                    key={item.id}
                    onClick={() => navigate(`/houserentdetails/${item.id}`)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="machine-img-container">
                      <img
                        src={`${UPLOADS.WORKSPACE_IMAGE}${images[imageIndexes1[item.id] || 0]}`}
                        alt="workroom"
                      />
                      {images.length > 1 && (
                        <>
                          {(imageIndexes1[item.id] || 0) > 0 && (
                            <button
                              className="img-arrow left-arrow"
                              onClick={(e) => prevImage1(e, item)}
                            >
                              <i className="bi bi-chevron-left"></i>
                            </button>
                          )}

                          <button
                            className="img-arrow right-arrow"
                            onClick={(e) => nextImage1(e, item, images)}
                          >
                            <i className="bi bi-chevron-right"></i>
                          </button>
                        </>
                      )}
                      {images.length > 1 && (
                        <div className="image-count">
                          <i className="bi bi-images me-1"></i>+
                          {images.length - 1}
                        </div>
                      )}
                      {/* <span className="heads-badge">{item.floor} </span> */}
                    </div>

                    <div className="machine-body">
                      <h4 className="machine-name">{item.location}</h4>
                      <div className="d-flex align-items-center justify-content-between mt-2">
                        <div className="price-block">
                          <span className="currency-symbol">₹</span>
                          <span className="amount">
                            {parseInt(item.rent_price).toLocaleString("en-IN")}
                          </span>
                          <span className="rent-unit"> </span>
                        </div>
                      </div>

                      <div className="spec-row mt-3 mb-2">
                        <div className="spec-item">
                          <span className="spec-label">Size:</span>
                          <span className="spec-value"> {item.size} </span>
                        </div>
                        <div className="spec-item">
                          <span className="spec-label">Floor:</span>
                          <span className="spec-value"> {item.floor}</span>
                        </div>
                      </div>

                      <div className="location-info">
                        <i className="bi bi-geo-alt-fill"></i>
                        {item.city},{item.state}
                      </div>

                      <div className="machine-footer mt-1">
                        <button
                          className="more-details-btn"
                          onClick={(e) => {
                            e.stopPropagation();

                            navigate(`/houserentDetails/${item.id}`, {
                              state: {
                                activeTab: "ownerInfo",
                              },
                            });
                          }}
                        >
                          <i className="bi bi-telephone-fill me-1"></i> Contact
                          Owner
                        </button>

                        <button
                          className="footer-like-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            removeFromWishlist(item.id, "house");
                          }}
                        >
                          <i className="bi bi-heart-fill text-danger"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              }

              /* ================= DESIGN ================= */
              if (item.type === "design") {
                return (
                  <div
                    className="design-card"
                    key={item.id}
                    data-aos="zoom-in-up"
                    onClick={() => handleCardClick(item)}
                  >
                    <div className="image-wrapper">
                      <img
                        src={`${API.BASE_URL}/uploads/Design_seller/${item.user_id}/${item.jpeg_file}`}
                        alt={item.design_code}
                      />
                    </div>
                    <div className="card-body">
                      <div className="design-specs">
                        <div className="spec-left">
                          <div>
                            <strong className="strong1">Code:</strong>{" "}
                            {item.design_code}
                          </div>
                          <div>
                            <strong className="strong1">Stitch:</strong>{" "}
                            {item.stitch}
                          </div>
                        </div>
                        <div className="spec-right text-start">
                          <div>
                            <strong className="strong1">Area:</strong>{" "}
                            {item.area}
                          </div>
                          <div>
                            <strong className="strong1">Color:</strong>{" "}
                            {item.color}
                          </div>
                        </div>
                      </div>

                      <h5 className="price-tag-row text-center mt-2">
                        ₹ {item.price}
                      </h5>
                      <div className="card-action-row">
                        <div className="action-btns">
                          <button
                            className={`select-btn ${
                              cartIds.includes(item.id) ? "selected-btn" : ""
                            }`}
                            onClick={async (e) => {
                              e.stopPropagation();

                              await addToCart(item);

                              // Remove from wishlist
                              removeFromWishlist(item.id, "design");
                            }}
                          >
                            <i
                              className={`bi ${
                                cartIds.includes(item.id)
                                  ? "bi-cart-check-fill"
                                  : "bi-cart-fill"
                              } me-1`}
                            ></i>
                            {cartIds.includes(item.id) ? "SELECTED" : "SELECT"}
                          </button>
                          <button
                            className="footer-like-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              removeFromWishlist(item.id, "design");
                            }}
                          >
                            <i className="bi bi-heart-fill text-danger"></i>
                          </button>
                          {/* <button
                            className="wish-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              // addToWishlist(item);
                            }}
                          >
                             <i
                              className={`bi ${wishlistIds.includes(item.id) ? "bi-heart-fill text-danger" : "bi-heart"}`}
                            ></i> 
                          </button> */}
                        </div>
                        {/* <div className="action-btns">
                          {downloaded[design.id] ? (
                            <button className="btn btn-teal1 btn-sm">
                              <i className="bi bi-check-circle-fill me-1"></i>
                              Downloaded
                            </button>
                          ) : (
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                triggerDownload(
                                  design.emb_file,
                                  design.category,
                                  design.design_code,
                                  design.id,
                                );
                              }}
                              className="btn btn-teal btn-sm"
                            >
                              <i className="bi bi-download me-1"></i>
                              Download
                            </button>
                          )}
                        </div> */}
                      </div>
                    </div>
                  </div>
                );
              }

              return null;
            })}
          </div>
        </div>
        <HorizontalAds />
        {/* ================= RIGHT ADS ================= */}
        {/* <div className="col-lg-2">
          <div className="ads-sidebar p-3 bg-white shadow-sm rounded text-center">
            <h5 className="ads-title">Sponsored</h5>

            <div className="ad-card mt-3">
              <div className="ad-placeholder">
                <p className="small text-muted">Your Ad Here</p>
              </div>

              <p className="small mt-2">Premium Threads Sale!</p>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
}
